import React from 'react';
import * as Styles from '../styles';
import { ChevronDown } from '@olxbr/ds-icons';
import { ChevronUp } from '@olxbr/ds-icons';
import { sendClickEvent } from '../../../utils/sendClickEvent';
export const TabContent = _ref => {
  let {
    children
  } = _ref;
  const [isExpanded, setIsExpanded] = React.useState(false);
  return React.createElement(Styles.TabWrapper, null, React.createElement(Styles.TabPanelShowMore, {
    className: isExpanded ? 'expanded' : ''
  }, children), React.createElement(Styles.ShowMoreButton, {
    variant: "link-button",
    size: "small",
    icon: isExpanded ? React.createElement(ChevronUp, null) : React.createElement(ChevronDown, null),
    "data-ds-component": "DS-TabPanel-Button",
    onClick: () => {
      setIsExpanded(prev => !prev);
      sendClickEvent('more_links', 'footer');
    }
  }, isExpanded ? 'Mostrar menos' : 'Mostrar mais'));
};